import React from 'react';
import {Button} from 'components';
import {config} from 'helpers';
import {RootState} from 'store';
import {Announcement} from './announcement';
import css from './announcement.module.scss';

export class Update_2025_05_19 extends Announcement {
  eligible(state: RootState) {
    return !state.settings.announcements?.[this.constructor.name] && config.gw;
  }

  render() {
    return (
      <>
        <h1><b>Plan My Week</b></h1>
        <p>A new 'Weekly Planning' process to identify, plan, and focus on your Next Week Objectives.</p>
        <p className={css.footer}>
          <Button onClick={this.props.decline}>
            {this.props.isLast ? 'close' : 'next'}
          </Button>
        </p>
      </>
    );
  }
}
